import { ShinseiService } from "@/service/ShinseiService";
import { ListSearchForm, ShinseiList } from "@/types/Shinsei";
import OptionConst from '@/const/Option';
import ShinseiOptionConst from '@/const/Shinsei/Option';
import { computed, ref } from "vue";
import { DialogService } from "@/service/DialogService";

/*
 * 申請一覧取得
 */
export function useShinseiList() {
  const loading = ref(0);
  const isError = ref(false);
  const shinseiList = ref<ShinseiList[]>();
  const shinseiListComponentType = ref('list');

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  // 一覧取得
  const getShinseiList = async (searchForm: ListSearchForm) => {
    loading.value++;

    const service = new ShinseiService();
    let res

    try {
      res = await service.getList(searchForm);
      if (searchForm.searchStatus == ShinseiOptionConst.SEARCH_STATUS.ZANGYOU) {
        shinseiListComponentType.value = 'zangyouList'; // 時間外／休憩未取得申請の結果をチャット風の画面で表示するためのコンポーネント
      } else {
        shinseiListComponentType.value = 'list'; // 通常の申請一覧
      }

      if (res) {
        shinseiList.value = res;
        await createDataList()
      }
    } catch (error) {
      await DialogService.info({ html: "繰り返しエラーが発生する場合は条件を絞り込んで検索してください" }, true);
    } finally {
      loading.value--;
    }
  };

  // 表示用に整形
  const createDataList = async () => {
    if (!shinseiList.value) {
      return
    }

    shinseiList.value.forEach(function (shinsei) {
      shinsei.kekka_type_str = OptionConst.SYOUNIN_STATUS_OPTION.find((val) => val.val === shinsei.syounin_status_type)?.label ?? null;
    })
  }

  return {
    isLoading,
    isError,
    shinseiList,
    getShinseiList,
    shinseiListComponentType,
  };
}
